var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuoteMark48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 37.23"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote-mark-48_svg__a",
  x1: 0.5,
  y1: 0.28,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9a13a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4000"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 17219"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2860",
  d: "M3.143 37.231A3.143 3.143 0 010 34.088v-11.17Q0 12.742 4.851 6.839A21.537 21.537 0 0114.852.2 3.143 3.143 0 0119 3.175v.786a3.12 3.12 0 01-1.9 2.885 13.247 13.247 0 00-7.4 6.774 12.1 12.1 0 00-1.017 5.767h7.5a3.143 3.143 0 013.143 3.143v11.558a3.143 3.143 0 01-3.143 3.143zM47.661 3.955a3.12 3.12 0 01-1.9 2.885 13.041 13.041 0 00-7.331 6.916 10.713 10.713 0 00-1.085 5.632h7.509A3.143 3.143 0 0148 22.53v11.558a3.143 3.143 0 01-3.143 3.143H31.811a3.143 3.143 0 01-3.143-3.143v-11.17q0-10.313 4.987-16.148a24.026 24.026 0 019.8-6.584 3.145 3.145 0 014.2 2.96z",
  fill: "url(#quote-mark-48_svg__a)"
}))));
export default __webpack_public_path__ + "static/quote-mark-48.77fb4c057da3800a995d96c015a5fcf2.svg";
export { SvgQuoteMark48 as ReactComponent };